import Navbar from "./scenes/Navbar";
import Landing from "./scenes/Landing";
import DotGroup from "./scenes/DotGroup";
import Services from "./scenes/Services";
import LineGradient from "./components/LineGradient";
import Products from "./scenes/Products";
import Contact from "./scenes/Contact";
import Footer from "./scenes/Footer";
import useMediaQuery from "./hooks/useMediaQuery";
import { useEffect, useState } from "react";
import CaseStudies from "./scenes/CaseStudies";
import { motion } from "framer-motion";

function App() {
  const [selectedPage, setSelectedPage] = useState("home");
  const [isTopOfPage, setIsTopOfPage] = useState(true);
  const isDesktop = useMediaQuery("(min-width: 1060px)");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsTopOfPage(true);
        setSelectedPage("home");
      }
      if (window.scrollY !== 0) setIsTopOfPage(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="app bg-deep-blue">
      <Navbar
        isTopOfPage={isTopOfPage}
        selectedPage={selectedPage}
        setSelectedPage={setSelectedPage}
      />
      <div className="w-5/6 mx-auto min-h-screen">
        {isDesktop && <DotGroup selectedPage={selectedPage} setSelectedPage={setSelectedPage} />}
        <motion.div onViewportEnter={() => setSelectedPage("home")}>
          <Landing setSelectedPage={setSelectedPage} />
        </motion.div>
      </div>
      <LineGradient />
      <div className="w-5/6 mx-auto min-h-screen mt-16">
        <motion.div onViewportEnter={() => setSelectedPage("services")}>
          <Services />
        </motion.div>
      </div>
      <LineGradient />
      <div className="w-5/6 mx-auto min-h-screen mt-16">
        <motion.div onViewportEnter={() => setSelectedPage("products")}>
          <Products />
        </motion.div>
      </div>
      <LineGradient />
      <div className="w-5/6 mx-auto min-h-screen mt-16">
        <motion.div onViewportEnter={() => setSelectedPage("case studies")}>
          <CaseStudies />
        </motion.div>
      </div>
      <LineGradient />
      <div className="w-5/6 mx-auto min-h-screen mt-16">
        <motion.div onViewportEnter={() => setSelectedPage("contact")}>
          <Contact />
        </motion.div>
      </div>
      <Footer />
    </div>
  );
}



export default App;
